import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  actionCategoryToggle,
} from 'Actions';
import * as styles from './selectedCategoriesInput.css';

const SelectedCategoriesInput = ({ id, label, onChange, checked }) => (
  <li className={styles.li} key={id}>
    <input
      className={styles.input}
      checked={checked}
      id={id}
      type="checkbox"
      onChange={onChange}
    /><label className={styles.label} htmlFor={id}>{label}</label>
  </li>
);

SelectedCategoriesInput.defaultProps = {
  checked: false,
};

SelectedCategoriesInput.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

const mapStateToProps = (
  { data: { selectedCategories = [] } }, // State Props
  { id } // Own Props
) => ({
  checked: -1 < selectedCategories.indexOf(parseInt(id, 10)),
});

const mapDispatchToProps = (dispatch) => ({
  onChange: (id) => dispatch(actionCategoryToggle(parseInt(id, 10))),
});

const mergeProps = (stateProps, { onChange }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onChange: () => onChange(ownProps.id),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SelectedCategoriesInput);

// Testing exports
export {
  SelectedCategoriesInput,
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
};



// WEBPACK FOOTER //
// ./app/components/selectCategoriesInput/index.js